module.exports = __webpack_public_path__ + "img/03_noff_open_L3.893263ad.svg";